import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ 
  variant = 'primary', 
  size = 'md', 
  to, 
  fullWidth = false,
  children, 
  className = '',
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100';

  const sizeClasses = {
    xs: 'px-2.5 py-1 text-xs',
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
  };

  const variantClasses = {
    primary: 'bg-primary-600 text-white hover:bg-primary-700 hover:shadow-md active:bg-primary-800 shadow-sm',
    secondary: 'bg-secondary-100 text-secondary-900 hover:bg-secondary-200 hover:shadow-sm active:bg-secondary-300 border border-secondary-200',
    outline: 'bg-white text-secondary-700 hover:bg-secondary-50 hover:border-secondary-400 active:bg-secondary-100 border border-secondary-300 shadow-sm',
    danger: 'bg-red-600 text-white hover:bg-red-700 hover:shadow-md active:bg-red-800 shadow-sm',
    ghost: 'bg-transparent text-secondary-600 hover:bg-secondary-100 hover:text-secondary-900 active:bg-secondary-200',
    text: 'bg-transparent text-primary-600 hover:text-primary-700 hover:underline active:text-primary-800',
  };

  const widthClasses = fullWidth ? 'w-full' : '';
  const buttonClasses = `${baseClasses} ${sizeClasses[size] || sizeClasses.md} ${variantClasses[variant] || variantClasses.primary} ${widthClasses} ${className}`.trim();

  if (to) {
    return (
      <Link to={to} className={buttonClasses} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <button className={buttonClasses} {...props}>
      {children}
    </button>
  );
};

export default Button;